// First, we need to import the FlatList and other React Native component
import "intersection-observer";
import React, { Component } from "react";
// We also need to add the connectInfiniteHits connector to our import
import { connectInfiniteHits } from "react-instantsearch-dom";
import ButtonBase from "@material-ui/core/ButtonBase";
import withStyles from "@material-ui/core/styles/withStyles";
import Colors from "../../constants/Colors";
import Avatar from "./Avatar";

const styles = theme => ({
  list: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 20
  },
  name: {
    color: Colors.text
  },
  widthDiv: {
    width: "100%"
  }
});

class Hits extends Component {
  onSentinelIntersection = entries => {
    const { hasMore, refine } = this.props;

    entries.forEach(entry => {
      if (entry.isIntersecting && hasMore) {
        // if (hasMore) {
        refine();
      }
    });
  };

  sentinel = null;

  componentDidMount() {
    this.observer = new IntersectionObserver(this.onSentinelIntersection);
    this.observer.observe(this.sentinel);
  }

  componentWillUnmount() {
    this.observer.disconnect();
  }

  isSelected = userId => {
    return (
      this.props.selectionList.findIndex(el => {
        if (!el) {
          return false;
        }
        if (el._id && el._id._id) {
          return el._id._id === userId;
        } else if (el._id) {
          return el._id === userId;
        }
        return false;
      }) > -1
    );
  };

  isMyTeam = userId => {
    return this.props.managerTeam.findIndex(el => {
      if (!el) {
        return false;
      }
      if (el._id && el._id._id) {
        return el._id._id === userId;
      } else if (el._id) {
        return el._id === userId;
      }
      return false;
    });
  };

  render() {
    const { hits, classes, selectionList, isTeam, managerTeam } = this.props;
    return (
      <div className={classes.list}>
        {this.props.hits.map((item, index) => {
          const { _id, picture, firstName, lastName } = item;
          if (
            (selectionList && this.isSelected(_id)) ||
            (isTeam && !this.isMyTeam(_id))
          ) {
            return "";
          }
          return (
            <Avatar
              key={_id}
              item={item}
              id={_id}
              picture={picture}
              firstName={firstName}
              lastName={lastName}
              onClick={this.props.selectTeamMember(item)}
            />
          );
        })}
        <div
          className="ais-InfiniteHits-sentinel"
          ref={c => (this.sentinel = c)}
        />
      </div>
    );
  }
}

export default connectInfiniteHits(withStyles(styles)(Hits));
